<section class="common-questions-container op-body-2" *transloco="let t">
	<mat-accordion class="common-questions-accordion common-questions">
		<mat-expansion-panel expanded="true">
			<mat-expansion-panel-header>
				<mat-panel-title class="op-header-3"> {{ t('CO_APP.COMMON_QUESTIONS.heading') }}</mat-panel-title>
			</mat-expansion-panel-header>
			<mat-accordion class="common-questions-accordion common-questions" multi="true">
				<ng-container *ngFor="let question of t('CO_APP.COMMON_QUESTIONS.' + questionType + '.items')">
					<mat-expansion-panel expanded="false" class="hr">
						<mat-expansion-panel-header>
							<mat-panel-title class="op-body-2-bold-font op-body-2-font"> {{ t(question.question) }}</mat-panel-title>
						</mat-expansion-panel-header>
						<label class="op-body-2-font op-light-black op-mt-4"
							>{{
								t(question.answer, {
									primaryApplicant: data?.firstName | titlecase
								})
							}}
						</label>
					</mat-expansion-panel>
				</ng-container>
			</mat-accordion>
		</mat-expansion-panel>
	</mat-accordion>
</section>
